/**
 * @generated SignedSource<<62ed7440e71e5c8e6f67fefb166f7d3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageNeedsAttentionBanner_customer$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetPackageNeedingAttention_customer">;
  readonly " $fragmentType": "PackageNeedsAttentionBanner_customer";
};
export type PackageNeedsAttentionBanner_customer$key = {
  readonly " $data"?: PackageNeedsAttentionBanner_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageNeedsAttentionBanner_customer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageNeedsAttentionBanner_customer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPackageNeedingAttention_customer"
    }
  ],
  "type": "Customer",
  "abstractKey": null
};

(node as any).hash = "11dbea2957a6a775db1caae26527840e";

export default node;
